import React from "react";
import { Send } from "lucide-react";
import { PROJECT } from "../lib/constants";

export const Footer = () => {
    return (
        <footer
            id="community"
            data-testid="footer-section"
            className="relative bg-[#0a0806] border-t-2 border-pink-brand"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="text-center max-w-3xl mx-auto">
                    <div className="font-mono-soft text-xs uppercase tracking-[0.3em] text-yellow-brand mb-4">
                        // Join the cup squad
                    </div>
                    <h2 className="font-display text-6xl sm:text-7xl md:text-8xl uppercase leading-[0.9] mb-6">
                        Be <span className="text-pink-brand">early.</span><br />
                        Be <span className="text-yellow-brand">loud.</span>
                    </h2>
                    <p className="text-lg text-white/70 mb-10">
                        Real community. Real engagement. Real bullish energy. We're building $LBRON one cup at a time.
                    </p>
                    <a
                        href={PROJECT.telegram}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-telegram-cta"
                        className="inline-flex items-center gap-3 bg-pink-brand text-white px-8 py-5 font-display text-2xl uppercase tracking-wide hover:bg-yellow-brand hover:text-[#0a0806] transition-colors brutal-shadow-yellow"
                    >
                        <Send className="w-6 h-6" />
                        Join Telegram
                    </a>
                    <div className="mt-6 font-mono-soft text-xs text-[#a19d9a] tracking-widest">
                        {PROJECT.telegram.replace("https://", "")}
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-[#a19d9a]">
                    <div className="font-display text-2xl">
                        <span className="text-pink-brand">LE</span>
                        <span className="text-yellow-brand">BON</span>
                        <span className="text-pink-brand">BON</span>
                        <span className="text-white/40 text-base ml-2 font-mono-soft">/ $LBRON</span>
                    </div>
                    <div className="font-mono-soft text-xs uppercase tracking-widest">
                        © {new Date().getFullYear()} LeBonBon · Not financial advice · Just memes
                    </div>
                </div>
            </div>
        </footer>
    );
};
